import { theme } from "antd"

const { useToken: useAntdToken } = theme
export const useToken: typeof useAntdToken = () => {
    return useAntdToken()
}